import React, { Component} from 'react';
 
import API from'../utilities/API'
import {  NavLink, Redirect  } from 'react-router-dom'

class Profile {
  constructor(props) {
    //this.user = this.props.usr;
  
    this.username = '';
    this.err='';
  }
}

class UserEdit extends Component {
 
  constructor(props) {
    super(props);

    let curUname = '';
    if(!props.data.usr.username){ curUname = props.data.usr.email }else{  curUname = props.data.usr.username }
    this.state = {
      usr: props.data.usr, 
      uname: curUname,
      upwd:'',
      logged:false,
      setUser : props.data.SetUser,
      errE: '',
    }
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);   
    this.validate = this.validate.bind(this);
    this.submitReturn = this.submitReturn.bind(this);
    
   }



handleSubmit = e => {    
    e.preventDefault();  
    //API.login(this.state.uname, this.state.upwd, this.handleLoginRet);
    let myProfile = new Profile();
    myProfile.username = this.state.uname;
    let validity = this.validate(myProfile);
    if(validity.isValid){
      let Req = {...this.state.usr}; 
      console.log('Update usr',Req);
      Req.username = myProfile.username; 
      API.profileRequest(Req, this.submitReturn);
   
    }else
    {
    
      this.setState({errE:validity.err}); 
    };   
     
    };
 submitReturn = r =>{
   console.log(r);
   if(!r.newuser){
     //alert(r);
    //console.log('R',r);
    this.setState({errE:r}); 
   }else{
    console.log('RRRRRRrrrr', r.newuser);
    this.props.setUser(r.newuser);
    this.setState({errE:'User Name changed, USE EMAIL TO LOGIN STILL!' });
    // this.state.setUser(r.newuser);
   }
  
 }; 
 validate = profile => {
   console.log(profile.username);
   let valid = {isValid:false,
                err: ''};
   let voidtest = /Void|v0id|v01d/i;   
   if (voidtest.test(profile.username))
   {
      valid.err += 'Thou shall not use the word void in your username.';
   }
   
   if(!API.antIsClean(profile.username))
   {
     
     valid.err += 'Unclean name, shun, shun, shun... no profanity please.'
   }
   if(profile.username.length < 3){
    valid.err += 'User Names must be at least 4 characters long.'
   }

   if (valid.err.length ===0){
    valid.isValid = true;
   }
  return(valid);
  
 }
    



  handleOnChange = event => {
      event.preventDefault();
      const { name, value } = event.target;
      
      this.setState({
        [name]: value
      });
    }

   
    render() { 
      //
      return (!this.state.usr)?(<Redirect to='/'/>):(
              <div className='mypage fluid-container p-3'>
                <h2>Edit Your Public Profile</h2>
                
                <div className='row'>
                <div className='myfldlbl col-12 mx-2'>Email and Login: </div>
                <div className='col-xs-12 col-sm-6 col-md-4 mx-2'>
                <input disabled className="form-control" value = {this.state.usr.email} name="emailaddy" type='text'/>
                  </div>
                  </div>

                <div className='row'>
                <div className='myfldlbl col-12 mx-2'>UserName</div>
                <div className='col-xs-12 col-sm-6 col-md-4 mx-2'><input maxLength="30" className="form-control" name="uname" value={this.state.uname}  onChange={this.handleOnChange} type='text'/></div>
                <div className='myerr col-12 mx-2 my-2'>{this.state.errE}</div>
                </div>
  
           
                <div className='row'>
                  <div className='col-3 mx-2'>
                    <div className="btn btn-dark mt-2" value="" to="/"  onClick={this.handleSubmit}>Submit</div>
                  </div>
                  <div className='col-3 mx-2'>
                  
                </div>
                <div className='col-3 mx-2'>
                    
                  </div>
                </div>
                </div>
                 
                
              );            
              
  
      
    }  

  
}




export default UserEdit; 


// WEBPACK FOOTER //
// ./src/components/UserEdit.js